import axios from "axios";
import { getAuthHeader } from "../../utils";

export const v2_get_sync_status = async (vesselId) => {
  const url = `${(window.RUNTIME_CONFIG?.API_BASE_URL ?? "")}/v2/sync/status/${vesselId}`;
  return axios.get(url, getAuthHeader()).then((res) => res.data);
};

export const v2_sync_push = async (vesselId) => {
  const url = `${(window.RUNTIME_CONFIG?.API_BASE_URL ?? "")}/v2/sync/push`;
  return axios.post(url, { vessel_id: vesselId }, getAuthHeader()).then((res) => res.data);
};
